var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 645.33 554.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#821c02;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.7,192.51S92.54,191.56,30.24,424.66c0,0-60.3-280.89,252.7-301.89,0,0,410.58-222.92,300.29,303C583.23,425.81,508.47,246.25,305.7,192.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.45,348.07l23.33,35.47a6.75,6.75,0,0,0,12.38-3.61L85.58,282a5.06,5.06,0,0,0-9.69-2.11L48,343.25A5.07,5.07,0,0,0,48.45,348.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.73,319.93,513.26,408A5.06,5.06,0,0,0,522,411.9l38.59-41.68a5,5,0,0,0,1.34-3.42l.15-46.37a5.06,5.06,0,0,0-5.06-5.07H526.77A5.06,5.06,0,0,0,521.73,319.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.47,310.14l15.91,9.28a5.34,5.34,0,0,0,7.75-2.82l16.43-50.51a5.32,5.32,0,0,1,6.91-3.21L162,275.57a5.29,5.29,0,0,0,7-3.69l8.36-38.55a5.34,5.34,0,0,1,8.68-2.73l63.78,55a5.32,5.32,0,0,0,8.72-3l10.72-65.95c.85-5.27,8.51-5.85,10.21-.78l6,17.88c1.64,4.86,8.89,4.6,10.13-.37l5-20.14c1.3-5.18,9-5.16,10.25,0l14,57.26a5.34,5.34,0,0,0,9.66,1.41l26.84-43.84c2.62-4.28,9.41-2.76,9.79,2.19l3.71,48c.34,4.39,6,6.3,9.09,3.08l33.19-34a5.36,5.36,0,0,1,8.85,1.88l8.5,24.75a5.35,5.35,0,0,0,9.57.92h0c2.59-4.35,9.47-2.84,9.83,2.16l2.69,37.43c.34,4.71,6.62,6.44,9.52,2.62l8-10.63c3.31-4.36,10.49-1.38,9.44,3.92l-5.36,27.1a5.19,5.19,0,0,0,6.77,5.77l42.64-13a5.22,5.22,0,0,0,3-2.39l35.5-62.34a4.92,4.92,0,0,0-1.37-6.41L389.07,126.83a5.43,5.43,0,0,0-4.42-1l-132.6,29.18a5,5,0,0,0-.86.26L130,204a5.2,5.2,0,0,0-2.71,2.47L78.46,303.62A5,5,0,0,0,80.47,310.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135,182s1.9-242.7,247.12-86.45l-120,77.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.18,284.8S5.53,122.66,155.73,157.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.24,424.66S-38.39,304,35.27,244.4L53.77,257,35.18,328.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M601,301.51s54.5,63.34-17.79,124.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.94,159.77s-4.3-.25-11.23-1.1C73.56,154.86-10.9,138.93,1.17,79,15.94,5.77,57.22-10.77,85.58,6s86.36,82.77,74.36,132.77S115.94,159.77,115.94,159.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,390.62s85,138.46,37,161.81-47.7-127.77-47.7-127.77l.29-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.67,390.45s85,138.46,37,161.8-47.7-127.76-47.7-127.76l.29-30Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset19);
export default __webpack_public_path__ + "static/media/Asset 19.90d501d1.svg";
export { ForwardRef as ReactComponent };